<template>
  <div id="main" class="home-page">
    <!-- 用户信息 -->
    <div id="userinfo">
      <!-- 头像 -->
      <img class="avatar" :src="userInfo.avatar" />
      <!-- 用户 -->
      <div class="info-container">
        <!-- 昵称 -->
        <div class="name" v-if="!whiteable">
          <p class="nickname">{{ developerInfo.nickname }}</p>
          <!-- <template v-if="developerInfo.state !== undefined">
            <a
              class="txt bg-normal"
              v-if="developerInfo.state == 0 || developerInfo.state == 3"
              :href="registerUrl"
              target="_blank"
              @click="becomeDeveloper"
              >成为开发者</a
            >
            <span class="txt bg-developer" v-else>
              开发者Lv {{ developerInfo.level }}</span
            >
          </template> -->
        </div>
        <div class="name" v-else>
          <p class="nickname">{{ developerInfo.nickname }}</p>
          <template v-if="developerInfo.state !== undefined">
            <a
              class="txt bg-normal"
              v-if="developerInfo.state == 0 || developerInfo.state == 3"
              href="https://dev-wiki.mini1.cn/cyclopdeia?wikiMenuId=1634&wikiId=805"
              target="_blank"
              @click="becomeDeveloper"
              >成为创作者</a
            >
            <span class="txt bg-developer" v-else>
              创作者Lv {{ developerInfo.level }}</span
            >
          </template>
        </div>
        <!--暂时屏蔽权益部分-->
        <!-- <div class="name-wrap" v-else>
          <div class="nickname">{{ developerInfo.nickname }}</div>
          <div class="rights">
            <template v-if="developerInfo.state !== undefined">
              <a
                class="account bg-normal"
                v-if="developerInfo.state == 0 || developerInfo.state == 3"
                :href="registerUrl"
                target="_blank"
                @click="becomeDeveloper"
                >成为创作者</a
              >
              <span class="account bg-developer" v-else>
                创作者Lv.{{ accountScore.lv }}</span
              >
              <div class="value-wrap">
                <span class="bg-thValue">
                  <span class="desc">创想值:</span>
                  <span class="number">{{ nowScore || 0 }} </span>/{{
                    nextScore || 0
                  }}</span
                >
                <div class="progress">
                  <div
                    class="complete-progress"
                    v-bind:style="{ width: completeWidth + '%' }"
                  ></div>
                  <div
                    class="other-progress"
                    v-bind:style="{ width: otherWidth + '%' }"
                  ></div>
                </div>
              </div>
            </template>
          </div>
        </div> -->
        <!-- 迷你号 & 详情 -->
        <div class="account">
          <span>迷你号：{{ userInfo.uin }}</span>
          <span>作品：{{ developerInfo.product }}</span>
          <span>关注：{{ developerInfo.follow }}</span>
          <span>粉丝：{{ developerInfo.fans }}</span>
          <!-- 暂时不做 -->
          <!-- <div class="fans-rise">
            <img src="@/assets/images/icon_arrow_up.png" />
            <span>20</span>
          </div> -->
        </div>
      </div>
      <!-- <div class="account-click" @click="routerClick" v-if="whiteable">
        账号权益
      </div> -->
    </div>

    <!-- 公告-->
    <div id="announcement">
      <div class="content-wrap">
        <div class="title-wrap">
          <span class="title"> 公告</span>
        </div>
        <div class="list1" v-if="annoceSliceData.length" id="tran-list">
          <transition name="el-zoom-in-top">
            <div v-show="show">
              <div
                class="list-unit"
                v-for="(item, index) in annoceSliceData"
                :key="index"
              >
                <a
                  :href="item.jumpUrl"
                  target="_blank"
                  class="jump_url"
                  @click="postMessage(item.id)"
                >
                  <div class="list-content">
                    <div class="type">{{ item.type }}</div>
                    <!-- <span class="list-wrap"> -->
                    <div class="list-wrap">
                      <div class="content">{{ item.title }}</div>
                      <div class="label1" v-if="item.tagIdsNew">
                        {{ item.tagIdsNew }}
                      </div>
                      <div class="label" v-if="item.tagIds">
                        {{ item.tagIds }}
                      </div>
                    </div>
                    <!-- </span> -->

                    <span class="date"> {{ item.createTime }}</span>
                  </div>
                </a>
              </div>
            </div>
          </transition>
        </div>
        <div class="list-no" v-else>
          <img class="img" src="@/assets/images/img_table_no_data.png" />
          <div class="desc">暂无公告</div>
        </div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div id="carousel" v-if="slideArr.length">
      <el-carousel indicator-position="outside" @change="bannerShow">
        <el-carousel-item v-for="item in slideArr" :key="item.id">
          <a :href="item.jump_url" target="_blank">
            <img
              :src="item.image_url"
              :alt="`图片${item.id}`"
              @click="bannerClick(item.id)"
          /></a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 总览 -->
    <div
      id="overview"
      :class="{ mask: developerInfo.state == 0 || developerInfo.state == 3 }"
    >
      <!-- 标题 和 说明 -->
      <div class="explain-wrap">
        <div id="pandect-title">
          <div class="title-wrap">
            <div class="title-name">概览</div>
          </div>
          <HelpTip>
            <pre slot="regular" class="detail-des">
广告收益：玩家观看作品内的广告后产生的收益；
贡献点：玩家使用迷你币消费您的作品或道具；
迷你点：玩家使用迷你点购买了作品或资源
迷你豆：玩家使用迷你豆购买了作品或资源；
下载次数：地图作品被玩家下载的累计次数
浏览次数：地图作品详情页（工坊或大厅内）被玩家查看的累计次数
游玩次数：地图作品被玩家进入游玩累计次数
游玩时长：地图作品被玩家进入停留游玩的累计时长
            </pre>
          </HelpTip>
        </div>
        <p class="explain-txt">过去30日累计数据</p>
        <i class="division-line"></i>
      </div>
      <!-- 数据卡片 -->
      <div id="card-wrap" v-loading="loading">
        <div class="item income-area">
          <div @click="toPage('income/data')" class="type-title">
            <a> 收益<span>></span> </a>
          </div>
          <div class="card-content">
            <cpn-cards
              class="card-content-item"
              :data="item"
              v-for="(item, index) in incomeData"
              :key="'incomeData' + index"
            ></cpn-cards>
          </div>
        </div>
        <div class="item income-area">
          <div @click="toPage('charts/map')" class="type-title">
            <a> 地图<span>></span> </a>
          </div>

          <div class="card-content">
            <cpn-cards
              class="card-content-item"
              :data="item"
              v-for="(item, index) in mapData"
              :key="'mapData_' + index"
            ></cpn-cards>
          </div>
        </div>
        <div class="item income-area">
          <div @click="toPage('charts/resource')" class="type-title">
            <a> 资源<span>></span> </a>
          </div>

          <div class="card-content">
            <cpn-cards
              class="card-content-item"
              :data="item"
              v-for="(item, index) in resourceData"
              :key="'resourceData_' + index"
            ></cpn-cards>
          </div>
        </div>
      </div>

      <!-- 遮罩层内容 -->
      <Masking
        v-if="developerInfo.state == 0 || developerInfo.state == 3"
        :height="480"
        :left="32"
        :homeType="true"
      ></Masking>
    </div>
    <!--学院课程展示-->
    <div id="college">
      <div class="title-wrapper">
        <div class="title">
          <span class="title-content">学院</span>
          <span class="more">
            <a href="https://dev-wiki.mini1.cn/" target="_blank">查看更多</a>
          </span>
        </div>
        <div class="desc">{{ contentTitle }}</div>
      </div>
      <div class="college-content" v-if="collegeClass.length">
        <div
          class="img-content"
          v-for="(item, index) in collegeClass"
          :key="index"
        >
          <a :href="item.url" target="_blank" @click="postCollege(item.id)">
            <el-image class="image-cover" :src="item.cover" alt="照片加载出错">
            </el-image>
            <div class="class-intro">
              <span class="intro">{{ item.title }}</span>
              <!-- <span class="count">{{ item.visitorsCount || 0 }}</span> -->
            </div>
          </a>
        </div>
      </div>
      <div class="list-no" v-else>
        <img class="img" src="../assets/images/img_table_no_data.png" />
        <div class="desc">暂无推荐课程</div>
      </div>
    </div>
  </div>
</template>

<script>
import cpnCards from './charts/components/cpn-cards.vue';
import { getHomeOverview, getBanners } from '@/api/common';
import { getAccountEquity } from '@/api/account';
import { repeatCertify } from '@/api/common';
import { createRegisterUrl } from '@/utils';
import Masking from '@/components/Masking';
import HelpTip from '@/components/HelpTip';
import { getKfzInfo, getAnnoce, getCollege } from '@/api/common';
import { getBankInfo } from '@/api/income';
import { mapState } from 'vuex';
import { RegistryReferer } from '@/types';
// import {reportData} from '@/main.js'
export default {
  components: {
    'cpn-cards': cpnCards,
    Masking,
    HelpTip,
  },
  data() {
    return {
      registerUrl: createRegisterUrl(RegistryReferer.Home),
      incomeData: [],
      show: true,
      mapData: [],
      completeWidth: 0,
      otherWidth: 100,
      resourceData: [],
      slideArr: [],
      num: 0,
      annoceCount: 0,
      accountScore: {},
      nowScore: 0,
      nextScore: 0,
      contentTitle: '',
      annoceSliceData: [
        // {
        //   jumpUrl: 'www.baidu.com',
        //   type: '通知',
        //   tagIds: 'HOT',
        //   title:
        //     ' 收益数据为预估数据，最终收益以入账后金额为准，具体细则请查看《收益结算说明》具体细则请查看《收益结算说明》',
        //   createTime: '2021-11-15'
        // },
        // {
        //   jumpUrl: 'www.baidu.com',
        //   type: '通知',
        //   tagIds: 'HOT',
        //   title:
        //     ' 收益数据为预估数据，最终收益以入账后金额为准，具体细则请查看《收益结算说明》具体细则请查看《收益结算说明》',
        //   createTime: '2021-11-15'
        // },
        // {
        //   jumpUrl: 'www.baidu.com',
        //   type: '通知',
        //   tagIds: 'HOT',
        //   title:
        //     ' 收益数据为预估数据，最终收益以入账后金额为准，具体细则请查看《收益结算说明》具体细则请查看《收益结算说明》',
        //   createTime: '2021-11-15'
        // }
      ],
      timer: null, //定义定时器
      loading: false,
      index: 0,
      //是否加入427白名单
      whiteable: false,
      percentage: 50,
      studioRegisterStatus: {},
      //  loginFormUrl:false
      annoceData: [],
      collegeClass: [],
    };
  },
  created() {
    sessionStorage.removeItem('vipInfo');
    if (this.userInfo.loginFormUrl) {
      this.twoNewCertify();
    } else {
      this.twoCertify();
    }
    let version = '';
    //判断是否是427版本
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.whiteable = false;
      } else {
        this.whiteable = false;
      }
    }
    this.init();
    this.Report('view', 'HomePage');
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  //清除事件
  destroyed() {
    //清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    init() {
      this.fetchBanners();
      this.fetchBankInfo();
      this.fetchKfzInfo();
      this.getAnnoceData();
      this.miinShow();
      //  this.fetchAccountInfo();
      // if (this.annoceData > 3) {
      //   this.setTime();
      // }

      //获取学院信息
      this.getCollegeClass();
    },
    // format(percentage) {
    //   return percentage === 100 ? '满' : `${percentage}%`;
    // },
    postMessage(id) {
      this.$log('announcement_click', 85701, { v7: 1, v8: id });
    },
    postCollege(id) {
      this.$log('course_click', 85702, { v7: 1, v8: id });
    },
    async twoCertify() {
      let data = {
        uin: this.userInfo.uin,
      };
      let res = await repeatCertify(data);
      let token2 = sessionStorage.getItem('token2');
      // console.log(token2)
      if (res.code === 500 && !token2) {
        //   debugger;
        this.$router.push({
          name: 'Certify',
          params: { uin: this.userInfo.uin },
        });
      }
    },
    //获取学院课程
    async getCollegeClass() {
      const res = await getCollege({});
      if (res.data) {
        this.contentTitle = decodeURIComponent(res.data.title);
        this.collegeClass = res.data.articleList;
      }
    },
    setTime() {
      //document.getElementById('tran-list').classList.remove('list');
      this.timer = setInterval(this.upDateData, 5000);
    },
    routerClick() {
      this.$router.push({ path: '/account/equity' });
    },
    async upDateData() {
      // this.num++;
      // console.log(this.num);
      await setTimeout((this.show = false), 100);
      await setTimeout((this.show = true), 200);
      // this.show = !this.show;
      if (this.index + 3 >= this.annoceCount) {
        this.annoceSliceData = this.annoceData.slice(
          this.index,
          this.index + 3,
        );
        this.index = 0;
      } else {
        this.annoceSliceData = this.annoceData.slice(
          this.index,
          this.index + 3,
        );
        this.index = this.index + 3;
      }
    },
    async twoNewCertify() {
      let data = {
        uin: this.userInfo.uin,
      };
      let res = await repeatCertify(data);
      let token2 = sessionStorage.getItem('token2');
      // console.log('++++'+token2)
      //  debugger
      console.log('---' + res.code);
      if (res.code === 500 && !token2) {
        //  debugger;
        this.$router.push({
          name: 'Certify',
          params: { uin: this.userInfo.uin },
        });
      }
    },
    //获取公告数据
    async getAnnoceData() {
      let data = { size: 15 };
      let now_date = new Date(new Date() - 14 * 24 * 60 * 60 * 1000).getTime();
      const res = await getAnnoce(data);
      this.annoceData = res.data.map(item => {
        if (item.createTime * 1000 > now_date) {
          item.tagIdsNew = 'NEW';
        } else {
          item.tagIdsNew = '';
        }
        item.createTime = this.timeConvert(item.createTime);
        (item.type = item.type === 1 ? '活动' : '通知'),
          (item.tagIds = item.tagIds === '1' ? 'HOT' : '');
        item.title = decodeURIComponent(item.title);
        // item.title =
        //   '创作者中心创作者中心创作者中心创作者中心创作者中心创作者创作者中心创作者中心创作者创做';
        item.jumpUrl = decodeURIComponent(item.jumpUrl);
        return item;
      });
      this.annoceCount = res.data.length;
      this.annoceSliceData = this.annoceData.slice(0, 3);
      this.index = this.index + 3;
      if (this.annoceCount > 3) {
        this.setTime();
      }
    },
    //将时间戳转化为年-月-日
    timeConvert(time) {
      let date = new Date(time * 1000);
      let year =
        date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let result = year + '-' + month + '-' + day;
      return result;
    },
    async fetchKfzInfo() {
      // 优化请求次数 - beforeEach 中已请求一次
      let info = JSON.parse(sessionStorage.getItem('developerInfo') || '{}');
      if (!Object.keys(info).length) {
        const res = await getKfzInfo();
        info = res.data;
      }

      // 非开发者造蒙层假数据
      if (info.state == 0 || info.state == 3) {
        this.incomeData = [
          {
            title: '广告收益',
            value: 500,
            yes: 100,
          },
          {
            title: '贡献点',
            value: 500,
            yes: 100,
          },
          { title: '迷你点', value: 500, yes: 100 },
          { title: '迷你豆', value: 500, yes: 100 },
        ];
        this.mapData = [
          {
            title: '下载次数',
            value: 500,
            yes: 100,
          },
          {
            title: '浏览次数',
            value: 500,
            yes: 100,
          },
          {
            title: '游玩次数',
            value: 500,
            yes: 100,
          },
          {
            title: '游玩时长(分钟)',
            value: 500,
            yes: 100,
          },
        ];
        this.resourceData = [
          {
            title: '解锁人数',
            value: 500,
            yes: 100,
          },
          {
            title: '浏览次数',
            value: 500,
            yes: 100,
          },
          {
            title: '下载次数',
            value: 500,
            yes: 100,
          },
        ];
      } else {
        this.fetchHomeOverview();
      }
    },
    async fetchBankInfo() {
      const res = await getBankInfo();
      this.$store.commit('SET_BANK_INFO', res.data);
    },
    // 获取首页数据
    async fetchHomeOverview() {
      this.loading = true;
      try {
        const res = await getHomeOverview();
        const { data } = res;
        this.incomeData = [
          {
            title: '广告收益',
            value: data.ad_income,
            yes: data.old_ad_income,
          },
          {
            title: '贡献点',
            value: data.contribution,
            yes: data.old_contribution,
            toFixed: 3,
          },
          { title: '迷你点', value: data.minipoint, yes: data.old_minipoint },
          { title: '迷你豆', value: data.minibean, yes: data.old_minibean },
        ];
        this.mapData = [
          {
            title: '下载次数',
            value: data.map_download_count,
            yes: data.old_map_download_count,
          },
          {
            title: '浏览次数',
            value: data.map_browse_count,
            yes: data.old_map_browse_count,
          },
          {
            title: '游玩次数',
            value: data.map_play_count,
            yes: data.old_map_play_count,
          },
          {
            title: '游玩时长(分钟)',
            value: data.map_play_time / 60,
            yes: data.old_map_play_time / 60,
            toFixed: 1,
          },
        ];

        this.resourceData = [
          // todo 确认后端数据字段
          {
            title: '解锁人数',
            value: data.res_unlock_people,
            yes: data.old_res_unlock_people,
          },
          {
            title: '浏览次数',
            value: data.res_browse_count,
            yes: data.old_res_browse_count,
          },
          {
            title: '下载次数',
            value: data.res_download_count,
            yes: data.old_res_download_count,
          },
        ];

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 获取banner
    async fetchBanners() {
      try {
        const res = await getBanners();
        this.slideArr = res.data.list;
      } catch (error) {
        console.log(error);
      }
    },
    //轮播图点击埋点
    bannerClick(id) {
      this.$log('banner_click', 85403, { v7: 1, v8: id });
    },
    //主页展示埋点
    miinShow() {
      this.$log('miin_show', 85401, { v7: 1 });
      if (this.developerInfo.state == 0 || this.developerInfo.state == 3)
        this.beDeveloperShow();
    },
    //获取创想值和所需要分数
    async fetchAccountInfo() {
      let res = await getAccountEquity({});
      this.accountScore = res.data;
      let arr = this.accountScore.config;
      //let nowLvData=arr[]
      //this.nowScore
      //this.nowLvData = arr[this.accountScore.lv];
      //判断是否是最高级
      if (arr.length) {
        //判断等级是否达到最高级
        console.log(this.accountScore.lv);
        console.log(arr[arr.length - 1].l);
        if (this.accountScore.lv === arr[arr.length - 1].l) {
          this.nextScore = arr[arr.length - 1].s - arr[arr.length - 2].s;
          this.nowScore = arr[arr.length - 1].s - arr[arr.length - 2].s;
        }
        for (let i = 0; i < arr.length - 1; i++) {
          if (this.accountScore.lv === arr[i].l) {
            this.nowScore = this.accountScore.score - arr[i].s;
            this.nextScore = arr[i + 1].s - arr[i].s;
          }
        }
        this.completeWidth = (this.nowScore / this.nextScore) * 100;
        this.otherWidth =
          ((this.nextScore - this.nowScore) / this.nextScore) * 100;
      }
    },
    //轮播图展示埋点
    bannerShow(key1) {
      let id1 = this.slideArr[key1].id;
      this.$log('banner_show', 85402, { v7: 1, v8: id1 });
    },
    //成为开发者按钮展示
    beDeveloperShow() {
      this.$log('become_developer_show', 85404, { v7: 1 });
    },
    //成为开发者点击埋点
    becomeDeveloper() {
      this.$log('become_developer_click', 85405, { v7: 1 });
    },
    toPage(path) {
      this.$router.push('./' + path);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.home-page {
  background: transparent;
  padding: 0;
}
#main {
  display: flex;
  flex-flow: column;
  width: 100%;
  min-height: 100%;
}

#userinfo {
  display: flex;
  margin-bottom: 24px;
  background-color: white;
  border-radius: 8px;
  padding: 20px;

  .avatar {
    width: 100px;
    height: 100px;
    background: #eee;
    border-radius: 50%;
    margin-right: 40px;
  }
  .account-click {
    font-size: 14px;
    line-height: 17px;
    color: #8c8c8c;
    text-decoration: underline;
    cursor: pointer;
    opacity: 1;
  }
  .info-container {
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    flex: 1;
    .name {
      display: flex;
      align-items: center;
      .nickname {
        font-size: 16px;
        margin-right: 20px;
      }
      .txt {
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 18px;
        font-size: 16px;
        color: #fff;
        padding: 0 20px;
      }
      a {
        text-decoration: none;
      }
      .bg-normal {
        background-color: $--color-primary;
        cursor: pointer;
        &:hover {
          filter: brightness(110%);
        }
      }
      .bg-developer {
        background-color: #253b51;
      }
      .bg-thValue {
        .desc {
          margin-right: 2px;
        }
        margin: 0 10px;
        margin-top: 4px;
        font-size: 16px;
      }
    }
    .name-wrap {
      .nickname {
        line-height: 19px;
        color: #262626;
        opacity: 1;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .rights {
        display: flex;
        .account.bg-developer,
        .account.bg-normal {
          display: inline;
          height: 22px;
          background: #3cacf6;
          opacity: 1;
          border-radius: 11px;
          font-weight: 400;
          line-height: 19px;
          color: #ffffff;
          font-size: 12px;
          padding: 2px 6px 3px;
        }
        .value-wrap {
          font-size: 12px;
          margin-top: -2px;
          margin-left: 12px;
          .bg-thValue {
            color: #8c8c8c;
          }
          .desc {
            margin-right: 6px;
          }
          .number {
            color: #3cacf6ff;
          }
        }
        .progress {
          width: 100%;
          display: flex;
          .complete-progress {
            height: 6px;
            background: linear-gradient(90deg, #3c87ff 0%, #43ffff 100%);
            opacity: 1;
            border-radius: 18px;
            margin-top: -1px;
          }
          .other-progress {
            height: 4px;
            background: #34a9fdff;
            opacity: 0.2;
            margin-left: -2px;
            margin-top: 0.4px;
            border-radius: 18px;
          }
        }
        // .el-progress {
        //   margin-top: -3px;
        //   ::v-deep.el-progress__text {
        //     display: none;
        //   }

        //   ::v-deep.el-progress-bar__inner {
        //     height: 6px !important;
        //     background: linear-gradient(90deg, #3c87ff 0%, #43ffff 100%);
        //     opacity: 1;
        //     margin-top: -0.8px;
        //     border-radius: 18px;
        //   }
        //   ::v-deep.el-progress-bar__outer {
        //     overflow: visible;
        //     width: 100px;
        //     height: 4px;
        //     background: #34a9fdff;
        //     //opacity: 0.2;
        //     border-radius: 18px;
        //   }
        // }
      }
    }
    .account {
      display: flex;
      align-items: center;
      font-size: 14px;

      span {
        padding: 0 40px;
        border-right: 1px solid #d9d9d9;
      }
      span:nth-child(1) {
        padding-left: 0;
      }
      span:nth-child(4) {
        border-right: none;
        padding-right: 0;
      }
      .fans-rise {
        border: 1px solid #ffc973;
        padding: 0 15px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        background: #fffaed;
        margin-left: 19px;
      }
    }
    .account_detail {
      display: flex;
      & > div {
        margin-right: 50px;
      }
      a {
        margin-right: 10px;
      }
      span {
        color: #bb9a9a;
      }
    }
  }
}

#carousel {
  margin-bottom: 10px;
  overflow: hidden;
  height: 254px;
  a {
    display: block;
    width: 100%;
    height: 220px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
  .el-carousel__item {
    background-color: #fff;

    border-radius: 8px;
  }
  img {
    width: 100%;
  }
}

#overview {
  min-height: 480px;
  background-color: white;
  border-radius: 8px;
  padding: 18px 32px 0;

  .explain-txt {
    color: #8c8c8c;
    font-size: 14px;
  }
}
#college {
  min-height: 360px;
  height: 100%;
  background-color: #fff;
  margin-top: 24px;
  padding: 20px;
  border-radius: 8px;
  color: #595959;
  .title-wrapper {
    .title {
      padding-bottom: 18px;
      .title-content {
        font-size: 24px;
      }
      .more {
        float: right;
        margin-right: 10px;
        vertical-align: middle;
        margin-top: 10px;
        a {
          color: #595959;
          text-decoration: none;
        }
      }
    }
    .desc {
      font-size: 18px;
      padding-bottom: 15px;
    }
  }
  .college-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .img-content {
      margin-right: 20px;
      margin-bottom: 20px;
      width: 220px;
      cursor: pointer;
      a {
        color: #262626;
        text-decoration: none;
      }
      .image-cover {
        width: 220px;
        height: 165px;
      }
      .class-intro {
        font-size: 18px;
        padding-top: 10px;
        .intro {
          max-width: 220px;
          display: inline-block;
          white-space: nowrap; /*超出的空白区域不换行*/
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*文本超出显示省略号*/
        }
        .count {
          float: right;
          margin-right: 5px;
          color: #595959;
        }
      }
    }
  }
  .list-no {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .desc {
      margin-top: 8px;
      font-size: 18px;
    }
    .intro-content {
      //vertical-align: middle;
      margin-top: 60px;
    }

    //flex-direction: row;
  }
}
#announcement {
  height: 220px;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
  .content-wrap {
    padding: 18px 32px 0;
    height: 100%;
    .list {
      padding: 13px 40px 0;
      color: #4d4d4d;
      //transition: height 3s;
      animation: duration 1s infinite;
      .list-unit {
        margin-bottom: 18px;
        font-size: 16px;
        .type {
          font-weight: 600;
          color: #333333;
          margin-right: 30px;
          font-size: 18px;
          // padding-top: -5px !important;
        }
        a {
          text-decoration: none !important;
        }
        .content {
          margin-right: 15px;
          margin-top: 3px;
          display: inline-block;
        }
        .label1 {
          background-color: #ff8c00;
          color: #fff;
          font-size: 10px;
          padding: 3px 3px;
        }
        .label {
          background-color: #ff8c00;
          color: #fff;
          margin-right: 10px;
          font-size: 10px;
          padding: 3px 3px;
        }
        .date {
          margin-right: 10px;
          float: right;
          color: #8c8c8c;
        }
      }
    }
    .list1 {
      padding: 10px 15px 0 40px;
      color: #262626;
      .list-unit {
        margin-bottom: 15px;
        font-size: 16px;
        .list-content {
          display: flex;
          align-items: center;
          .type {
            font-weight: 600;
            color: #333333;
            margin-right: 30px;
            font-size: 18px;
            display: inline-block;
            // padding-top: -5px !important;
          }
          // .list-wrap {
          // flex: 1;
          .list-wrap {
            flex: 1;
            display: flex;
            align-items: center;
            white-space: nowrap; /*超出的空白区域不换行*/
            overflow: hidden; /*超出隐藏*/
            text-overflow: ellipsis; /*文本超出显示省略号*/
          }
          .content {
            margin-right: 15px;
            color: #262626;
            white-space: nowrap; /*超出的空白区域不换行*/
            overflow: hidden; /*超出隐藏*/
            text-overflow: ellipsis; /*文本超出显示省略号*/
          }
          .label {
            background-color: #ff8c00;
            color: #fff;
            height: 18px;
            display: inline-block;
            padding: 1px 3px;
            font-size: 8px;
            //margin-top: 5px;
            border-radius: 2px;
          }
          .label1 {
            background-color: #ff8c00;
            color: #fff;
            display: inline-block;
            height: 18px;
            padding: 1px 3px;
            font-size: 8px;
            //margin-top: 5px;
            margin-right: 5px;
            border-radius: 2px;
          }
          // }

          .date {
            //margin-right: 10px;
            //padding-top: 3px;
            //margin-left: 45px;
            //display: inline-block;
            color: #8c8c8c;
            margin-left: 15px;
            //float: right;
          }
        }

        a {
          text-decoration: none !important;
        }
      }
    }
    @keyframes duration {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .list-no {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .desc {
        margin-top: 8px;
        font-size: 18px;
      }
      .intro-content {
        //vertical-align: middle;
        margin-top: 60px;
      }

      //flex-direction: row;
    }
  }
  .title-wrap {
    color: #595959;
    font-size: 24px;
  }
}
#help {
  img {
    padding-left: 10px;
  }
}
.explain-wrap {
  .division-line {
    width: 100%;
    height: 1px;
    background: #d9d9d9;
    margin: 16px 0 20px;
    display: block;
  }
}
#pandect-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  div {
    display: flex;
  }
  p {
    font-weight: bold;
    font-size: 24px;
    color: #333;
  }
  a {
    color: #bb9a9a;
    font-size: 16px;
  }
  .title-wrap {
    font-size: 24px;
    color: #595959;
  }
}

#card-wrap {
  display: flex;
  flex-direction: column;
  .item {
    min-height: 178px;
    display: flex;
    flex-direction: column;
    .card-content {
      display: flex;
      justify-content: flex-start;
      .card-content-item {
        margin-left: 10px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
  .type-title {
    margin-bottom: 10px;
    cursor: pointer;
    & a {
      font-size: 16px;
    }
    & span {
      margin-left: 12px;
    }
  }
}

#card {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .chosen {
    border: 4px solid #bbb;
    background-color: #fbeded;
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      right: -4px;
      width: 0;
      height: 0;
      border: 15px solid;
      border-left-color: transparent;
      border-right-color: #bbb;
      border-top-color: transparent;
      border-bottom-color: #bbb;
    }
  }
}

.tips-wrap {
  width: 350px;
  font-size: 14px;
  line-height: 1.5;
  .content-wrap {
    margin-bottom: 20px;
  }
  .tip-line {
    width: 100%;
    height: 1px;
    background: #fcefef;
    margin-bottom: 10px;
  }
  .detail-des {
    margin-top: 10px;
    padding: 0 10px;
    .update-time {
      color: #bfa2a0;
    }
  }
}

table {
  width: 100%;
}
::v-deep .el-carousel__button {
  width: 10px;
  height: 10px;
  background-color: #c7c5c5;
  border-radius: 5px;
}
::v-deep .el-carousel__container {
  height: 220px;
}
.mask {
  position: relative;
}
</style>
